import { IdentityRepository } from '../ports/IdentityRepository';
import { UserSession } from '../entities/UserSession';

export class GetSessionUseCase {
  constructor(private identityRepo: IdentityRepository) {}

  async execute(uid: string, email: string, metadata?: any): Promise<UserSession> {
    const profile = await this.identityRepo.getProfile(uid);
    const role = await this.identityRepo.getRole(uid);

    let storeId: string | undefined;
    let merchantId: string | undefined;

    if (role.isStaff()) {
      const assignment = await this.identityRepo.getStaffAssignment(uid);
      if (assignment) {
        storeId = assignment.storeId;
        merchantId = assignment.ownerId;
      }
    } else if (role.isOwner()) {
      merchantId = uid;
    }

    return new UserSession({
      uid,
      email,
      role,
      mustChangePassword: profile?.mustChangePassword || false,
      storeId,
      merchantId,
      displayName: profile?.fullName || metadata?.full_name
    });
  }
}
